import request from "./request";
/**
 * 增加绑定用户
 * @param userId 绑定用户id
 * @param userName 绑定用户名称
 * @param pageName 专页名称
 * @param pageId 专页id
 */
export default async function addBindUser(data) {
  return await request.post("/spin/dataAuthorizationPlayer/addBindUser", data);
}
